import { __read, __spreadArray } from "tslib";
export var StorageTag = function (name) { return "[" + name + "]"; };
export var ModuleTag = function (namespack, module) { return namespack + "/" + module; };
export var MethodTag = function (module, methodName) { return "[" + module + "." + methodName + "]"; };
export var ArgumentTags = function (args) {
    var tags = Array.isArray(args)
        ? args
        : Object.keys(args)
            .filter(function (key) { return args[key] !== undefined; })
            .map(function (key) { return key + "=" + args[key]; });
    return tags.length ? __spreadArray(['args:'], __read(tags)) : [];
};
export var EventTag = function (event) { return "[-* " + event + "]"; };
/**
 * Create a cost tag generator to trace to cost among events
 * @returns A cost tag generator which will automatic count the duration from last called generator
 */
export var createCostTracer = function () {
    var last = Date.now();
    return function () {
        var now = Date.now();
        var tag = "+" + (now - last) + "ms";
        last = now;
        return tag;
    };
};
//# sourceMappingURL=tag.js.map